import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-manual-barcode-entry-modal',
  templateUrl: './manual-barcode-entry-modal.component.html',
  styleUrls: ['./manual-barcode-entry-modal.component.css']
})
export class ManualBarcodeEntryModalComponent implements AfterViewInit {

  @ViewChild('manualBarcodeInput') manualBarcodeInputElement: ElementRef;
  @Input() submitCallback: (barcode: string) => undefined = null;

  public barcode = '';

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngAfterViewInit() {
    this.manualBarcodeInputElement.nativeElement.focus();
  }

  public handleInputClick() {
    setTimeout(
      () => { this.manualBarcodeInputElement.nativeElement.focus(); },
      50
    );
  }

}
